module.exports = __webpack_public_path__ + "img/192.d4b5bf8d.jpg";